import { ButtonProps, Col, Form } from "antd";
import { FormListProps } from "antd/lib/form";
import React from "react";
import { ButtonC, FormItemC, IconC } from "..";

interface FormListBuilderProps {
  formListProps?: FormListProps;
  children: any;
  buttonAddTitle?: string;
  addBtnProps?: ButtonProps;
  label?: string;
  showBtn?: boolean;
}
const FormListBuilder = (props: FormListBuilderProps) => {
  const {
    formListProps,
    children,
    buttonAddTitle,
    addBtnProps,
    label,
    showBtn = true,
  } = props;

  return (
    <div className="SwitchComponent" style={{ margin: "10px" }}>
      {label && <label>{label}</label>}
      <Form.List {...(formListProps as any)}>
        {(fields, { add, remove }, { errors }) => (
          <>
            {fields.map((field, index) => children({ field, remove, index }))}
            {showBtn ? (
              <FormItemC>
                <ButtonC
                  style={{ width: "100%", marginBottom: "20px" }}
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<IconC type="PlusOutlined" />}
                  {...addBtnProps}
                >
                  {buttonAddTitle}
                </ButtonC>

                <Form.ErrorList errors={errors} />
              </FormItemC>
            ) : null}
          </>
        )}
      </Form.List>
    </div>
  );
};

export default FormListBuilder;
